module.exports = __webpack_public_path__ + "media/Icons/camera-pos/cam_4-a500b97096d835201d9e7f296a40990a.png";